import { render, staticRenderFns } from "./bankTxImportTable.vue?vue&type=template&id=5603dec3&"
import script from "./bankTxImportTable.vue?vue&type=script&lang=ts&"
export * from "./bankTxImportTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports